import React, { memo } from 'react';

import { Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

import { SKELETON_TYPES } from 'constants/skeleton';

import { WIDTH, WIDTH_2, WIDTH_3 } from './ListItem.constants';

const ListItem = ({ type, cellsNumber = 7 }) => {
  const renderContent = () => {
    switch (type) {
      case SKELETON_TYPES.LIST:
        return (
          <>
            <Skeleton animation="pulse" variant="text" width="280px" />
            <Skeleton animation="pulse" className="ml-20" variant="text" width="80px" />
          </>
        );

      case SKELETON_TYPES.TABLE:
        return Array.from({ length: cellsNumber }).map((_, index) => (
          <Skeleton
            animation="pulse"
            key={index}
            variant="text"
            width={`${Math.floor(WIDTH / cellsNumber / (index % 2 ? WIDTH_2 : WIDTH_3))}%`}
          />
        ));

      case SKELETON_TYPES.TEXT_INPUT:
        return <Skeleton animation="pulse" className="h-48" variant="rectangular" width="100%" />;

      default:
        return null;
    }
  };

  return <div className="w-full flex items-center justify-between px-20">{renderContent()}</div>;
};

ListItem.propTypes = {
  type: PropTypes.string.isRequired,
  cellsNumber: PropTypes.number,
};

export default memo(ListItem);
